import { useState } from 'react'
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import Tooltip from './Tooltip';

const WhatsAppLink = ({link}) => {
     const [copied, setCopied] = useState(false)

     const encodedLink = encodeURIComponent(link);

        const copyToClipboard = () => {

            navigator.clipboard.writeText(`https://deccos-website.web.app/whatsapplink/${encodedLink}`)

            setCopied(true)
            setTimeout(() => {
                setCopied(false)
            }, 1000)
        }  
  return (
    <div className='copy-link-container'>
        <Tooltip content='Kopieer link' top='-60px'>
            <ModeCommentOutlinedIcon className='icon-margin-left' onClick={copyToClipboard} />
        </Tooltip>
        {copied && <p className='copied'>Gekopieerd!</p>}
    </div>
  )
}

export default WhatsAppLink